module.exports = __webpack_public_path__ + "img/poster.cc1a3735.png";